<template>
    <div id="hive-history-widget-component">
        <WidgetWrapperComponent :title="$t('global_apiary.history')" id-widget="hive-history-widget">
            <template v-slot:default>
                <template v-if="!loading_hive_history">
                    <v-data-iterator
                        :items="history"
                        :items-per-page.sync="items_per_page"
                        :no-data-text="$t('global_apiary.no_history')"
                        :page.sync="current_page"
                        hide-default-footer
                    >
                        <template v-slot:default="props">
                            <v-timeline dense>
                                <v-timeline-item v-for="step in props.items" :key="step.id_history" fill-dot>
                                    <v-card-text class="d-flex timeline-item-history">
                                        <span class="mb-0">
                                            {{ step.message_label }}
                                        </span>

                                        <v-spacer />

                                        <span class="mb-0 justify-end">
                                            <ChipsLastStatement :date="step.date_alert" colorless />
                                        </span>
                                    </v-card-text>
                                </v-timeline-item>
                            </v-timeline>
                        </template>

                        <template v-slot:footer>
                            <template>
                                <v-row class="d-flex justify-end">
                                    <v-col class="d-flex align-center" cols="auto">
                                        <span class="font-12 pr-4">{{ $t('global_apiary.element_per_page') }}</span>

                                        <v-select v-model="items_per_page" :items="[5, 10, 15]" class="select-item-per-page pr-4" />

                                        <span class="font-12 pr-4">{{ paginationInfo }}</span>

                                        <v-btn :disabled="current_page === 1" icon @click="previousPage">
                                            <v-icon>mdi-chevron-left</v-icon>
                                        </v-btn>

                                        <v-btn :disabled="current_page * items_per_page > total_items" icon @click="nextPage">
                                            <v-icon>mdi-chevron-right</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </template>
                        </template>
                    </v-data-iterator>
                </template>

                <v-skeleton-loader v-else type="list-item-avatar-two-line, list-item-avatar-two-line, list-item-avatar-two-line" />
            </template>
        </WidgetWrapperComponent>
    </div>
</template>

<script>
import WidgetWrapperComponent from '@/components/global/wrapper/WidgetWrapperComponent.vue'
import DeviceRepository from '@/repositories/DeviceRepository'
import ChipsLastStatement from '@/components/global/containment/ChipsLastStatement.vue'

export default {
    name: 'HiveHistoryWidgetComponent',
    components: { ChipsLastStatement, WidgetWrapperComponent },
    props: {
        idDevice: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            current_page: 1,
            items_per_page: 5,
            total_items: 0,
            loading_hive_history: false,
            history: [],
        }
    },
    created() {
        this.getHiveHistory()
    },
    computed: {
        paginationInfo() {
            const start = (this.current_page - 1) * this.items_per_page + 1
            const end = Math.min(this.current_page * this.items_per_page, this.total_items)
            return `${start}-${end} de ${this.total_items}`
        },
        totalPages() {
            return Math.ceil(this.total_items / this.items_per_page)
        },
    },
    methods: {
        getHiveHistory() {
            this.loading_hive_history = true

            DeviceRepository.getDeviceHistory(this.$props.idDevice, this.items_per_page, this.page)
                .then((response) => {
                    this.history = response.data.data.data
                    this.total_items = response.data.data.total_rows
                })
                .catch((error) => {
                    this.manageError(error)
                })
                .finally(() => {
                    this.loading_hive_history = false
                })
        },

        previousPage() {
            if (this.current_page > 1) {
                this.current_page--
            }
        },

        nextPage() {
            if (this.current_page < this.totalPages) {
                this.current_page++
            }
        },
    },
}
</script>

<style>
.timeline-item-history {
    background-color: #f5f7fb;
}

.select-item-per-page {
    max-width: 65px;
    font-size: 12px;
}
</style>
